export const FEATURES = { skills: true } as const
